import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';
const Backbone = require('backbone');

import { IGlob } from '../Glob';
import BaseStore from '../../../../_common/platform/ts/BaseStore';
import { Constants } from '../../../../_common/platform/ts/Constants';
import { apiCall } from '../../../../_common/platform/ts/AqlUtility';
import { WidgetBase } from '../../../../_common/platform/ts/WidgetBase';

import * as gridLayout from '../../tsx/layout/gridLayout';
import serializeWorkspace from '../../../../_common/platform/ts/serializeWorkspace';
import { deserializeWorkspace } from '../../../../_common/platform/ts/deserializeWorkspace';
import { IValuesCollection } from '../../../../_common/platform/ts/appTheme';

import { AppDispatcher as Dispatcher } from '../dispatcher/AppDispatcher';
import { Action, AppActions, I, check as checkAction } from '../actions/AppActions';
import { I as IW } from '../actions/WorkspaceActions';
import * as Utilities from '../../../../_common/platform/ts/Utilities';
import { IWidgetLayout } from '../../tsx/layout/Interfaces';

import {
    IActiveWidgets,
    IDrillDownWidgetParameters,
    IHTMLWidgetParameters,
    IWidget,
    IWidgetLocal
} from '../Interfaces';

//import ClipboardCopy from '../../tsx/ClipboardCopy';
import GlobalState from '../../../../_common/platform/ts/globalStates/GlobalState';
import { ITab } from './AppStore';
import { config } from '../config';

import {
    deleteClickToFilters,
    deleteWigetAttributeFilters
} from '../../../../_common/platform/tsx/filtering/FilterUtilities';

const update = require('immutability-helper');
const moment = require('pdc-platform-moment');

export interface ICreateLinkOptions {
    useGuidsAsWSID: boolean;
    anonymousLogin: boolean;
    distractFree: boolean;
    activeWidgets?;
    drillDownState?;
}

export enum WidgetLink_IncludeStates {
    'dbStateId',
    'urlParams'
}

export interface ICreateWidgetLinkOptions {
    anonymousLogin: boolean;
    showLogo: boolean;
    linkByName: boolean;
    useGuidsAsWSID: boolean;
    includeStateAs: number;
}

export interface IWorkspaceStoreState {
    loading: boolean;
    actionLoading: boolean;

    showDirsTemplates: boolean;
    showSidebar: boolean;

    instances: { [id: number]: IWorkspaceInstance };
    states: { [tab: number]: any };

    shownWorkspaces: { [id: number]: boolean };
    widgetRoles: { [tab: string]: { [widget: number]: string } };
}

interface IStoredObject {
    instances: { [id: number]: IWorkspaceInstance };
    states: string;
}

export interface IWorkspaceData {
    widgets?: IWidget[];
    widgetsLocal?: { [widgetID: number]: IWidgetLocal };
    theme?: IValuesCollection;
    layout?: IWidgetLayout;
}

export type DisplayMode = 'main' | 'widgets';

export interface IWorkspaceInstance {
    id: number;
    name?: string;
    data?: IWorkspaceData;
    Guid?: string;

    displayMode?: DisplayMode;
    showGrid?: boolean;
    edititngStarted?: boolean;
    showDirsTemplatesSidebar?: boolean; // this flag in instance state will override the flag set by 'Edit Workspace' command
    // it is set with special event from 'Nested Layout' widget

    originalData?: string;
    loading: boolean;
    isChildWorkspace: boolean;
    wsPathDir: string[]; //VR workspace dir path will be stored here, like: [Users, Leo]
    wsPathDirId: number[]; //VR workspace dir ID will be stored here, like: [4, 29]
    hiddenInTabs: number[];

    dateUpdated?: string;

    activeWidgets: IActiveWidgets; // For multiwidget container with nested widgets. The pairs of opened tabs is here
    drillDownState: { [drillDownWidget: number]: number }; // For drill down widgets. The pairs of active drilldown targets

    _defs: {
        initialLoad?: JQueryDeferred<any>;
    };
}

export function decodeHTMLWidgets(html: string) {
    return _.map(html.match(/__WIDGET_CONFIG_START__(.*?)__WIDGET_CONFIG_END__/g), (str) => {
        str = str.replace(/^__WIDGET_CONFIG_START__/, '').replace(/__WIDGET_CONFIG_END__$/, '');

        return JSON.parse(decodeURIComponent(escape(atob(str))))[0] as IWidget;
    });
}

export function encodeHTMLWidgets(html: string, widgets: IWidget[]) {
    widgets = widgets.slice(0);

    return html.replace(/__WIDGET_CONFIG_START__(.*?)__WIDGET_CONFIG_END__/g, (str) => {
        const widget = widgets.splice(0, 1)[0];

        return (
            '__WIDGET_CONFIG_START__' +
            btoa(unescape(encodeURIComponent(JSON.stringify([widget])))) +
            '__WIDGET_CONFIG_END__'
        );
    });
}

export class WorkspaceStore extends BaseStore<IWorkspaceStoreState, AppActions, Dispatcher, IGlob> {
    public _state: IWorkspaceStoreState;
    public static _name = 'workspace';

    public static getInitialState(): IWorkspaceStoreState {
        return {
            loading: false,
            actionLoading: false,
            showDirsTemplates: false,
            showSidebar: false,
            instances: {},
            shownWorkspaces: {},
            states: {},
            widgetRoles: {}
        };
    }

    private static getInitialInstanceState(id: number, defaults = false, wsName?: string): IWorkspaceInstance {
        let data: IWorkspaceData = null;
        let originalData: string = null;
        let name: string = null;

        if (defaults === true) {
            data = {
                widgets: [],
                widgetsLocal: {},
                layout: {
                    pos: [],
                    size: [],
                    columns: [this.getEmptyTableUnit()],
                    rows: [this.getEmptyTableUnit()]
                },
                theme: {}
            };

            originalData = serializeWorkspace(data, false);
            name = wsName || 'New Tab';
        }

        return {
            id: id,
            name: name,
            data: data,
            originalData: originalData,
            showDirsTemplatesSidebar: false,
            loading: false,
            hiddenInTabs: [],
            isChildWorkspace: false,
            activeWidgets: {},
            drillDownState: {},
            wsPathDir: [],
            wsPathDirId: [],
            _defs: {}
        };
    }

    public getInstanceState(id: number, defaults = false, wsName?: string): IWorkspaceInstance {
        let state = this._state.instances[id];

        if (state == null) {
            state = this._state.instances[id] = WorkspaceStore.getInitialInstanceState(id, defaults, wsName);
        }

        return state;
    }

    public setWorkspaceIsChild(id: number, isChildWorkspace: boolean) {
        const inst = this._state.instances[id];

        if (inst != null) {
            inst.isChildWorkspace = isChildWorkspace;
        }
    }

    private getStateKey(id: number, tab: number) {
        return id + '_' + tab;
    }

    private parseStateKey(key: string) {
        const parts = key.split('_');

        let workspaceID: number;
        let tabID: number;

        if (parts.length > 0) {
            workspaceID = parseInt(parts[0], 10);
            tabID = parseInt(parts[1], 10);
        } else {
            //17.05.2022: Old format.
            tabID = parseInt(parts[0], 10);
        }

        return {
            workspaceID,
            tabID
        };
    }

    public getWorkspaceState(id: number, tabID: number) {
        const stateKey = this.getStateKey(id, tabID);

        let result = this._state.states[stateKey];

        if (result == null) {
            let maxTabID = 0;
            let existingStateKey: string;

            for (let key in this._state.states) {
                const parsedKey = this.parseStateKey(key);

                if (parsedKey.workspaceID === id && maxTabID < parsedKey.tabID) {
                    maxTabID = parsedKey.tabID;
                    existingStateKey = key;
                }
            }

            this._state.states[stateKey] = result = {};

            if (maxTabID > 0) {
                const existingState = this._state.states[existingStateKey]['business-intelligence'];

                if (existingState != null) {
                    result['business-intelligence'] = { ...existingState };
                }
            }

            // const savedWorkspaces = this.glob.AppStore.getFromLocalStorage(LAST_CLOSED_WORKSPACES);

            // if (savedWorkspaces != null) {
            //     const closedWorkspaces = JSON.parse(savedWorkspaces);
            //     const closedWorkspace = closedWorkspaces[id];

            //     if (closedWorkspace != null) {
            //         result['business-intelligence'] = closedWorkspace.state;
            //         delete closedWorkspaces[id];

            //         this.glob.AppStore.saveToLocalStorage(LAST_CLOSED_WORKSPACES, JSON.stringify(closedWorkspaces));
            //     }
            // }
        }

        return result;
    }

    private setWorkspaceState(id: number, tabID: number, namespace, state): void {
        this.getWorkspaceState(id, tabID);

        const stateKey = this.getStateKey(id, tabID);

        this._state.states = update(this._state.states, {
            [stateKey]: {
                [namespace]: { $set: state }
            }
        });
    }

    private replaceWorkspaceState(state, id: number) {
        //if (tabID == null) {
        // accessing AppStore state here, dangerous point
        const tabID = this.glob.AppStore.getCurrentTabID();
        //}

        if (tabID == null) {
            return;
        }

        let wsState;
        let stateKey: string;

        for (let key in this._state.states) {
            if (this.parseStateKey(key).tabID === tabID) {
                wsState = this._state.states[key];
                stateKey = key;
            }
        }

        if (wsState == null) {
            wsState = {};
            stateKey = this.getStateKey(id, tabID);
        }

        _.each(_.keys(state), (key) => {
            let stateValue;

            if (wsState[key] instanceof Backbone.Model) {
                wsState[key].set(state[key]);
                stateValue = wsState[key];
            } else {
                stateValue = wsState[key] = state[key];
            }

            this.actions.workspaceSetState(id, tabID, key, stateValue);
        });

        this._state.states[stateKey] = wsState;
    }

    private serializeWorkspaceState(obj) {
        return JSON.stringify(obj, (key, value) => {
            if (value != null && typeof value === 'object' && typeof value.toJSON === 'function') {
                return value.toJSON();
            }

            return value;
        });
    }

    public serializeDataToStore(data: IWorkspaceStoreState): string {
        const statesToStore = {};
        const thresholdDate = new Date();
        const thresholdTime = thresholdDate.setMonth(thresholdDate.getMonth() - 1).valueOf();

        // Opening of a workspace always creates a new Global State.
        // Reopening of a closed workspace takes the last Global State to restore selections.
        // Global States that are previous to the last one are used only if the same workspace is opened in different tabs.
        // This code makes Local Storage cleaner by not saving empty states and the states that are older than 1 month ago.
        _.each(data.states, (state, key) => {
            if (!_.isEmpty(state)) {
                if (this.parseStateKey(key).tabID > thresholdTime) {
                    statesToStore[key] = state;
                }
            }
        });

        const states = this.serializeWorkspaceState(statesToStore);
        const obj: IStoredObject = {
            instances: data.instances,
            states: states
        };

        return JSON.stringify(obj, function (key, value) {
            if (key === '_defs') {
                return {};
            }

            if (key === 'showDirsTemplatesSidebar') {
                return undefined;
            }

            if (key === 'null') {
                return undefined;
            }

            if (this === obj.instances) {
                value = _.clone(value);
                value.data = serializeWorkspace(value.data, false);
            }

            return value;
        });
    }

    public deserializeStoredData(str: string) {
        const obj: IStoredObject = JSON.parse(str);

        _.each(obj.instances, (inst, key) => {
            inst.data = deserializeWorkspace(inst.data, this.glob);
        });

        const result: Partial<IWorkspaceStoreState> = {
            instances: obj.instances,
            states: JSON.parse(obj.states)
        };

        return result;
    }

    private static getEmptyTableUnit() {
        return {
            ratio: 1
        };
    }

    private findWidget(widgets: IWidget[], id: number) {
        if (widgets == null) {
            return {};
        }

        for (let index = 0; index < widgets.length; index++) {
            const widget = widgets[index];

            if (widget != null && widget.id === id) {
                return {
                    widget,
                    index
                };
            }
        }

        return {};
    }

    private workspaceShow(id: number, stateId, distractFree: boolean, activeWidgets: IActiveWidgets) {
        if (id == null || id < 0) {
            return;
        }

        if (this._state.shownWorkspaces[id] != null) {
            return;
        }

        const inst = this.getInstanceState(id);

        let silent = false;

        if (inst.name != null && inst.data != null) {
            silent = true;
        }

        if (activeWidgets != null) {
            inst.activeWidgets = activeWidgets;
        }

        inst.drillDownState = {};

        if (distractFree === true) {
            silent = false;
        }

        apiCall(this.actions, 'workspace_OnOpen', {
            wsid: id
        });

        this.actions.workspaceViewLoadContent(id, silent, stateId, distractFree);
        this._state.shownWorkspaces[id] = true;
    }

    private workspaceClearCache(id: number) {
        delete this._state.shownWorkspaces[id];

        const instance = this._state.instances[id];

        if (instance == null) {
            return;
        }

        instance.data = deserializeWorkspace(instance.originalData, this.glob);
    }

    private workspaceShowSidebar() {
        if (this._state.showSidebar) {
            return false;
        }

        this._state.showSidebar = true;
        return true;
    }

    private workspaceHideSidebar() {
        if (this._state.showSidebar === false) {
            return false;
        }

        this._state.showSidebar = false;
        return true;
    }

    private requestWorkspaceDataEx(id: number, isChildWorkspace: boolean) {
        return apiCall(this.actions, 'workspace_GetDataEx', {
            wsid: id,
            addToHistory: isChildWorkspace === false
        });
    }

    private requestState(id: number) {
        return apiCall(this.actions, 'statestorage_GetData', {
            id: id
        });
    }

    private workspaceLoadContent(id: number, silent: boolean, stateId, distractFree: boolean) {
        //'id' can be negative for virtual Workspaces as for browsing.
        if (id == null || id < 0) {
            return;
        }

        this._state.loading = true;

        const instance = this.getInstanceState(id);

        if (!silent) {
            instance.loading = true;
        }

        if (instance._defs.initialLoad != null && instance._defs.initialLoad.state() === 'pending') {
            return;
        }

        const def = $.Deferred();
        const defs = [this.requestWorkspaceDataEx(id, instance.isChildWorkspace)];

        //defs.push(this.requestDirPath(id)); // VR: get path

        if (stateId != null) {
            defs.push(this.requestState(stateId));
        }

        $.when
            .apply($, defs)
            .done((nameDataResp, stateResp) => {
                def.resolve(nameDataResp, stateResp);
            })
            .fail((obj) => {
                def.reject(obj);
            });

        instance._defs.initialLoad = def;

        def.done(
            (
                nameDataResp: {
                    result: {
                        name: string;
                        data?: string;
                        dateUpdated?: string;
                        diridpath?: number[];
                        dirpath?: string[];

                        dir_for_ws_permissions?: number;
                        ownerid?: number;
                        guid?: string;
                    };
                },
                stateResp: any
            ) => {
                const instance = this._state.instances[id]; //EVG: It must be redefined, because here referensing to the collection is lost.
                const responceResult = nameDataResp.result;
                const responseData = deserializeWorkspace(responceResult.data, this.glob);
                const dataFromServer = serializeWorkspace(responseData, true);

                let applyDataFromServer = distractFree;

                if (!applyDataFromServer) {
                    if (
                        instance.edititngStarted &&
                        instance.data != null &&
                        serializeWorkspace(instance.data, true) !== instance.originalData
                    ) {
                        // Workspace is modified.
                        applyDataFromServer = false;
                    } else {
                        applyDataFromServer = true;
                    }
                }

                if (applyDataFromServer) {
                    instance.name = responceResult.name;
                    instance.Guid = responceResult.guid;

                    if (responceResult.dirpath != null) {
                        instance.wsPathDir = responceResult.dirpath;
                    } else {
                        instance.wsPathDir = [];
                    }

                    if (responceResult.diridpath != null) {
                        instance.wsPathDirId = responceResult.diridpath;
                    } else {
                        instance.wsPathDirId = [];
                    }

                    if (responceResult.dateUpdated != null) {
                        instance.dateUpdated = responceResult.dateUpdated;
                    }

                    stateResp = stateResp && JSON.parse(stateResp.result);

                    if (stateResp && stateResp.theme == null) {
                        stateResp.theme = {};
                    }

                    let state;
                    let theme: IValuesCollection;

                    if (stateResp && stateResp.state != null && stateResp.theme != null) {
                        state = stateResp.state;
                        theme = stateResp.theme;
                    } else {
                        state = stateResp;
                    }

                    if (state != null) {
                        this.replaceWorkspaceState(state, id);
                    }

                    if (theme != null) {
                        this.actions.setWidgetTabTheme(null, theme);
                    }

                    instance.data = responseData;
                    instance.originalData = dataFromServer;
                } else if (instance.originalData !== dataFromServer) {
                    const instanceData = serializeWorkspace(instance.data, true);

                    if (instanceData !== dataFromServer) {
                        this.glob.DialogActions.createDialog(
                            'Workspace has been updated',
                            'Click Save As to save it with another name or Reload to get the latest changes from server.',
                            () => {
                                //this.actions.workspaceSave(id, instanceData, instance.dateUpdated);
                                this.actions.workspaceSaveAs(id, instanceData, false);
                            },
                            () => {
                                this.actions.workspaceReset(id);
                            },
                            () => {},
                            'confirm',
                            {
                                confirmTitle: 'Save As',
                                cancelTitle: 'Reload'
                            }
                        );
                    }
                }

                this.actions.workspaceViewLoadContentFinish(id, true);
            }
        );

        def.fail((obj) => {
            this.actions.workspaceViewLoadContentFinish(id, false);
        });
    }

    private workspaceLoadContentFinish(id: number, success: boolean) {
        this._state.loading = false;

        if (id == null) {
            return;
        }

        if (success) {
            this.glob.AppActions.workspaceSetHidden(id, false);
        }

        const instance = this.getInstanceState(id);

        // if (instance.activeWidgets != null) {
        //     _.each(_.keys(instance.activeWidgets), (key) => {
        //         const widgetState = { activeWidgets: instance.activeWidgets };

        //         //this.glob.AppActions.widgetSetState(parseInt(key), widgetState);
        //     })
        // }

        instance.loading = false;
    }

    private workspaceForeignUpdate(id: number, dateUpdated: string, updatedBy: number) {
        const instance = this.getInstanceState(id);

        if (
            instance == null ||
            instance.edititngStarted ||
            instance.loading ||
            moment(dateUpdated).isSameOrBefore(instance.dateUpdated, 'minute')
        ) {
            return;
        }

        const userDef = $.Deferred<any>();

        apiCall(this.actions, 'user_GetAccountInfo', { userid: updatedBy }, null, userDef);

        userDef.always((udResp) => {
            const { displayName } = udResp.result || {};
            const dateUpdatedLocal = new Date(dateUpdated);

            const message =
                `Workspace #${id} has been updated ${
                    displayName != null ? ' by ' + displayName : ''
                } at ${dateUpdatedLocal.toLocaleString()}. ` + 'Perform Reload to get the latest changes from server.';

            const remainderId = Utilities.getNewID();
            const _reactContent: React.JSX.Element = (
                <div
                    className="btn btn-default btn-xs"
                    onClick={() => {
                        this.actions.workspaceViewLoadContent(id, true, null, true);
                        this.actions.workspaceReset(id);
                        this.actions.cleanRemainderMessage(remainderId);
                    }}
                >
                    {'Reload'}
                </div>
            );

            this.glob.AppActions.showNotification_Info(message, null, {
                manualDestroy: true,
                remainder: true,
                reactContent: _reactContent,
                details: { id: remainderId }
            });
        });
    }

    // public decodeHTMLWidgets(html) {
    //     return decodeHTMLWidgets(html);
    // }

    // private encodeHTMLWidgets(html, widgets) {
    //     return encodeHTMLWidgets(html, widgets);
    // }

    public getWidgetsByIdDeep(widgets: IWidget[], id: number, res = [], ids = [], types = []) {
        const recur = [];

        const find = _.findIndex(widgets, (widget, i) => {
            const widgetType = widget.type;

            if (widgetType === config.widgetTypes.tabbedWidget || widgetType === config.widgetTypes.nestedLayout) {
                recur.push({
                    i: i,
                    type: widgetType,
                    id: widget.id || widget.cid,
                    widgets: widget.values[widgetType].widgets ?? []
                });
            } else if (widgetType === config.widgetTypes.drillDown) {
                recur.push({
                    i: i,
                    type: widgetType,
                    id: widget.id || widget.cid,
                    widgets: (widget.values[widgetType] as IDrillDownWidgetParameters).drillDown.widgets ?? []
                });
            } else if (widgetType === config.widgetTypes.html) {
                const html = (widget.values[widgetType] as IHTMLWidgetParameters).html;

                recur.push({
                    i: i,
                    type: widgetType,
                    id: widget.id || widget.cid,
                    widgets: (html && html.widgets) ?? []
                });
            }

            return widget.id === id;
        });

        if (find !== -1) {
            return [widgets[find], res.concat([find]), ids, types];
        }

        let returnValue = null;
        let recurObj;
        let i = 0;

        while (returnValue == null && i < recur.length) {
            recurObj = recur[i];
            returnValue = this.getWidgetsByIdDeep(
                recurObj.widgets,
                id,
                res.concat([recurObj.i]),
                ids.concat([recurObj.id]),
                types.concat([recurObj.type])
            );
            i += 1;
        }

        return returnValue;
    }

    public getWidgetsByTypeDeep(widgets: IWidget[], type, res = [], ids = [], types = []) {
        const recur = [];

        const find = _.findIndex(widgets, (widget, i) => {
            const widgetType = widget.type;

            if (widgetType === config.widgetTypes.tabbedWidget || widgetType === config.widgetTypes.nestedLayout) {
                recur.push({
                    i: i,
                    type: widgetType,
                    id: widget.id || widget.cid,
                    widgets: widget.values[widgetType].widgets ?? []
                });
            } else if (widgetType === config.widgetTypes.drillDown) {
                recur.push({
                    i: i,
                    type: widgetType,
                    id: widget.id || widget.cid,
                    widgets: (widget.values[widgetType] as IDrillDownWidgetParameters).drillDown.widgets ?? []
                });
            } else if (widgetType === config.widgetTypes.html) {
                const html = (widget.values[widgetType] as IHTMLWidgetParameters).html;

                recur.push({
                    i: i,
                    type: widgetType,
                    id: widget.id || widget.cid,
                    widgets: html?.widgets ?? []
                });
            }

            return widgetType === type;
        });

        if (find !== -1) {
            return [widgets[find], res.concat([find]), ids, types];
        }

        let returnValue = null;
        let recurObj;
        let i = 0;

        while (returnValue == null && i < recur.length) {
            recurObj = recur[i];
            returnValue = this.getWidgetsByTypeDeep(
                recurObj.widgets,
                type,
                res.concat([recurObj.i]),
                ids.concat([recurObj.id]),
                types.concat([recurObj.type])
            );
            i += 1;
        }

        return returnValue;
    }

    private getSaveStateUpdateObjectRec(rest, obj, restTypes): any {
        if (rest.length === 0) {
            return {
                $set: obj
            };
        }

        const widgetType = _.first<string>(restTypes);
        const widgetsUpdate = {
            [_.first<any>(rest)]: this.getSaveStateUpdateObjectRec(_.rest(rest), obj, _.rest(restTypes))
        };

        if (widgetType === config.widgetTypes.tabbedWidget || widgetType === config.widgetTypes.nestedLayout) {
            return {
                values: {
                    [widgetType]: {
                        widgets: widgetsUpdate
                    }
                }
            };
        } else if (widgetType === config.widgetTypes.drillDown) {
            return {
                values: {
                    [widgetType]: {
                        drillDown: {
                            widgets: widgetsUpdate
                        }
                    }
                }
            };
        } else if (widgetType === config.widgetTypes.html) {
            return {
                values: {
                    [widgetType]: {
                        html: {
                            widgets: widgetsUpdate
                        }
                    }
                }
            };
        }
    }

    private getSaveStateUpdateObject(chain, obj, types) {
        return {
            widgets: {
                [_.first(chain)]: this.getSaveStateUpdateObjectRec(_.rest(chain), obj, types)
            }
        };
    }

    private widgetSaveInstance(instance: IWorkspaceInstance, id: number, data: IWidget, local: boolean) {
        if (instance.data == null) {
            return;
        }

        const widgets = instance.data.widgets;

        if (widgets == null) {
            return;
        }

        const searchRes = this.getWidgetsByIdDeep(widgets, id);

        if (searchRes == null) {
            return;
        }

        const [widget, chain, ids, types] = searchRes;
        const obj: IWidgetLocal = {
            type: data.type,
            values: data.values,
            cid: widget.cid,
            id: widget.id,
            layout: data.layout,
            elements: widget.elements
        };
        const widgetID = obj.id || obj.cid;

        if (data.type !== widget.type && obj.layout != null && obj.elements != null) {
            obj.elements = [];
            obj.layout = null;
        }

        if (local !== true) {
            const newData = update(instance.data, this.getSaveStateUpdateObject(chain, obj, types));

            _.each(ids.concat([widgetID]), (id) => {
                delete newData.widgetsLocal[id];
            });

            if (serializeWorkspace(newData, true) !== instance.originalData) {
                instance.edititngStarted = true;
            }

            instance.data = newData;
        } else {
            instance.edititngStarted = true;
            instance.data.widgetsLocal[widgetID] = obj;
        }
    }

    public widgetSave(id: number, data: IWidget, ignoreWorkspace?: boolean, local?: boolean, workspaceID?: number) {
        if (ignoreWorkspace || id == null || this._state.instances == null) {
            return;
        }

        //EVG: The same WS opened in different tabs share the same Instance, so it's enougth to change the Instance only.
        if (workspaceID != null) {
            const instance = this._state.instances[workspaceID];

            if (instance != null) {
                this.widgetSaveInstance(instance, id, data, local);
                return;
            }
        }

        //EVG: However, this code changes all existing Instances.
        // It makes the difference Workspaces having widgets with the same ID be changed.
        // This code does not look right, but it might be correct in another use case.
        _.each(this._state.instances, (instance) => {
            this.widgetSaveInstance(instance, id, data, local);
        });
    }

    private widgetRemoveInstance(instance: IWorkspaceInstance, widgetID: number) {
        if (instance.data == null) {
            return;
        }

        const { widget, index } = this.findWidget(instance.data.widgets, widgetID);

        if (widget == null) {
            return;
        }

        const dataCopy = $.extend(true, {}, instance.data);

        //EVG: This is better because update() does not do type checking.
        dataCopy.layout.pos.splice(index, 1);
        dataCopy.layout.size.splice(index, 1);
        dataCopy.widgets.splice(index, 1);

        instance.data = dataCopy;

        // instance.data = update(instance.data, {
        //     layout: {
        //         pos: {
        //             $splice: [[index, 1]]
        //         },
        //         size: {
        //             $splice: [[index, 1]]
        //         }
        //     },
        //     widgets: {
        //         $splice: [[index, 1]]
        //     }
        // });
    }

    private widgetRemove(widgetID: number) {
        if (widgetID == null) {
            return;
        }

        _.each(this._state.instances, (inst) => {
            this.widgetRemoveInstance(inst, widgetID);
        });
    }

    private widgetDetachInst(instance: IWorkspaceInstance, widgetID: number) {
        if (instance.data == null) {
            return;
        }

        const { widget, index } = this.findWidget(instance.data.widgets, widgetID);

        if (widget == null) {
            return;
        }

        instance.data = update(instance.data, {
            layout: {
                pos: {
                    [index]: {
                        $set: null
                    }
                },
                size: {
                    [index]: {
                        $set: null
                    }
                }
            }
        });
    }

    private widgetDetach(id: number) {
        if (id == null) {
            return;
        }

        _.each(this._state.instances, (inst) => {
            this.widgetDetachInst(inst, id);
        });
    }

    private widgetAttach(
        wsId: number,
        parentWidgetId,
        id: number,
        x: number,
        y: number,
        remainSize: boolean,
        fresh: boolean
    ) {
        if (parentWidgetId != null) {
            return false;
        }

        if (wsId == null) {
            return false;
        }

        const instance = this.getInstanceState(wsId);

        if (instance.data == null) {
            return false;
        }

        const { widget, index } = this.findWidget(instance.data.widgets, id);

        if (widget == null) {
            return false;
        }

        instance.data.layout = gridLayout.elementAttach(instance.data.layout, index, x, y, remainSize, fresh, () => {
            this.actions.widgetRemove(id);
        });

        instance.data = _.clone(instance.data);

        return true;
    }

    private widgetCreateLink(workspace, widget, name: string, state, data, options: ICreateWidgetLinkOptions) {
        let wsid: string | number;

        if (options.useGuidsAsWSID) {
            const inst = this.getInstanceState(workspace);

            wsid = inst.Guid;
        } else {
            wsid = workspace;
        }

        let link =
            (options.anonymousLogin ? 'Anonymous.html' : '') +
            '?ws=' +
            'workspaces/' +
            wsid +
            '/widgets/' +
            (options.linkByName ? name : widget);

        let linkFull = location.href.replace(/#.*$/, '').replace('index.html', '') + link;

        const def = $.Deferred<{ result: any }>();

        if (options.includeStateAs === WidgetLink_IncludeStates.dbStateId) {
            if (state == null) {
                def.resolve();
            } else {
                apiCall(
                    this.actions,
                    'statestorage_Create',
                    {
                        name: 'name',
                        data: state
                    },
                    null,
                    def
                );

                def.done((resp) => {
                    const statePart = '/state/' + resp.result;

                    link += statePart;
                    linkFull += statePart;
                });
            }
        } else {
            def.resolve();
        }

        def.done((resp) => {
            if (data != null) {
                const dataPart = '/data/' + encodeURI(btoa(JSON.stringify(data)));

                link += dataPart;
                linkFull += dataPart;
            }

            if (options.includeStateAs === WidgetLink_IncludeStates.urlParams && state != null && state.length > 0) {
                const statePart = encodeURI(state);

                link += '&' + statePart;
                linkFull += '&' + statePart;
            }

            this.showLinkCreationResult(link, linkFull, 'widget ' + name);
        });
    }

    workspaceCreateLink(workspace: number, tab: number, name: string, params: string, options: ICreateLinkOptions) {
        let wsid: string | number;

        if (options.useGuidsAsWSID === true) {
            const inst = this.getInstanceState(workspace);

            wsid = inst.Guid;
        } else {
            wsid = workspace;
        }

        let link =
            (options.anonymousLogin ? 'Anonymous.html' : '') +
            '?ws=' +
            (tab != null ? 'tabs/-1' : '') + //-1 means that the workspace will be opened in the current tab.
            '/workspaces/' +
            wsid;

        let data: any = {};

        if (options.distractFree === true) {
            data.distractFree = true;
        }

        if (options.activeWidgets != null) {
            data.activeWidgets = options.activeWidgets;
        }

        if (options.drillDownState != null) {
            data.drilldown = options.drillDownState;
        }

        if (!_.isEmpty(data)) {
            const dataPart = '/data/' + encodeURI(btoa(JSON.stringify(data)));

            link += dataPart;
        }

        if (params != null && params !== '') {
            link += '&' + encodeURI(params);
        }

        const linkFull = location.href.replace(/#.*$/, '').replace('index.html', '') + link;
        const subject = name != null ? "'" + name + "'" : '';

        this.showLinkCreationResult(link, linkFull, 'workspace ' + subject);
    }

    private showLinkCreationResult(link: string, fullLink: string, subject: string) {
        const maxURLLen = config.URL_MAX_LENGTH - config.HTTP_REQUEST_HEADER_BUFFER_SIZE;

        if (fullLink.length * 2 >= maxURLLen) {
            this.actions.showNotification_Fail(
                `The length of the link exceeds the configured length of ${maxURLLen} bytes. <br/>Try to reduce the number of filter parameters.`,
                null
            );
        } else {
            if (navigator.clipboard == undefined) {
                this.actions.showNotification_Fail('Clipboard is not available on Unsecure website.');
                return;
            }
            navigator.clipboard.writeText(fullLink);
            link = link.replace(/&gt/gi, '&&#103;&#116;').replace(/&lt/gi, '&&#108;&#116;');

            this.actions.showNotification_Success(
                `Link to ${subject} has been copied to Clipboard. <br/>You also can use this one: <a class="visible-link" target="_blank" href="${link}">Click to open</a>`,
                null,
                {
                    manualDestroy: true
                    //reactContent: <ClipboardCopy text={fullLink} isButtonWithGlyph={true} />
                }
            );
        }
    }

    // See Issue 100154. Existing widgetsLocal prevents applying of changes.
    private cleanWidgetLocal(dataCopy: IWorkspaceData, widgetID: number, instance: IWorkspaceInstance) {
        if (dataCopy.widgetsLocal != null) {
            const widgetLocal = dataCopy.widgetsLocal[widgetID];

            if (widgetLocal != null) {
                instance.edititngStarted = true;
                delete dataCopy.widgetsLocal[widgetID];
            }
        }
    }

    private widgetSetLayout(workspaceID: number, widgetID: number, layout: IWidgetLayout) {
        const instance = this.getInstanceState(workspaceID);

        if (instance.data == null) {
            return;
        }

        const dataCopy = $.extend(true, {}, instance.data);
        const { widget } = this.findWidget(dataCopy.widgets, widgetID);

        if (widget == null) {
            return;
        }

        widget.layout = { ...layout };

        this.cleanWidgetLocal(dataCopy, widgetID, instance);
        instance.data = dataCopy;
    }

    private widgetAddField(workspace: number, widgetID: number, x: number, y: number, field) {
        const instance = this.getInstanceState(workspace);

        if (instance.data == null) {
            return;
        }

        const dataCopy = $.extend(true, {}, instance.data);
        const { widget } = this.findWidget(dataCopy.widgets, widgetID);

        if (widget == null) {
            return;
        }

        widget.layout.pos.push([x, y]);
        widget.layout.size.push([1, 1]);

        if (widget.elements == null) {
            widget.elements = [];
        }

        widget.elements.push(field);

        this.cleanWidgetLocal(dataCopy, widgetID, instance);
        instance.data = dataCopy;

        // instance.data = update(instance.data, {
        //     widgets: {
        //         [index]: {
        //             layout: {
        //                 pos: {
        //                     $push: [[x, y]]
        //                 },
        //                 size: {
        //                     $push: [[1, 1]]
        //                 }
        //             },
        //             elements: {
        //                 $apply: (val = []) => val.push(field) && val
        //             }
        //         }
        //     }
        // });
    }

    private widgetRemoveField(workspace: number, widgetID: number, positionIndex: number, shift = 1) {
        const instance = this.getInstanceState(workspace);

        if (instance.data == null) {
            return;
        }

        const dataCopy = $.extend(true, {}, instance.data);
        const { widget } = this.findWidget(dataCopy.widgets, widgetID);

        if (widget == null) {
            return;
        }

        widget.layout.pos.splice(positionIndex, 1);
        widget.layout.size.splice(positionIndex, 1);
        widget.elements.splice(positionIndex - shift, 1);

        this.cleanWidgetLocal(dataCopy, widgetID, instance);
        instance.data = dataCopy;
    }

    private widgetCreate(
        wsId: number,
        parentWidgetId: number,
        cid: number,
        data: IWidget,
        wsName: string,
        isVirtual: boolean
    ) {
        if (parentWidgetId != null) {
            return false;
        }

        if (wsId == null) {
            return false;
        }

        let inst: IWorkspaceInstance;

        if (data != null && wsName != null) {
            inst = this.getInstanceState(wsId, true, wsName);
        } else {
            inst = this.getInstanceState(wsId, true);
        }

        // VR: mistake??? if ((inst == null) || (inst.data == null)) { return; }
        if (inst == null || data == null) {
            return false;
        }

        const constr = WidgetBase.getConstructorByName(data.type);

        if (constr == null) {
            return false;
        }

        const res = constr.checkBeforeAdd(data, inst.data);

        if (res.result === false) {
            this.actions.showNotification_Fail(
                `The widget '${data.values[data.type].name}' cannot be added to workspace '${
                    inst.name
                }': ${res.errors.join(', ')}`
            );
            return false;
        }

        data.id = cid;

        inst.data = update(inst.data, {
            widgets: {
                $push: [data]
            },
            layout: {
                pos: {
                    $push: [[0, 0]] //Was: [null]
                },
                size: {
                    $push: [[1, 1]] //Was: [null]
                }
            }
        });

        if (isVirtual) {
            inst.originalData = serializeWorkspace(inst.data, false);
        }

        return true;
    }

    private widgetMultipleSetActive(wsId: number, parentWidgetID: number, activeWidgetID: number) {
        const inst = this.getInstanceState(wsId, true);

        if (inst == null) {
            return false;
        }

        if (inst.activeWidgets == null) {
            inst.activeWidgets = {};
        }

        inst.activeWidgets[parentWidgetID] = activeWidgetID;

        return true;
    }

    private widgetDrillDownSetState(wsId: number, drillDownWidget: number, targetWidget: number) {
        const inst = this.getInstanceState(wsId, true);

        if (inst) {
            if (inst.drillDownState == null) {
                inst.drillDownState = {};
            }

            if (targetWidget == null) {
                delete inst.drillDownState[drillDownWidget];
            } else {
                inst.drillDownState[drillDownWidget] = targetWidget;
            }
        }
    }

    private templatesExplorerShow() {
        this._state.showDirsTemplates = true;
    }

    private templatesExplorerHide() {
        this._state.showDirsTemplates = false;
    }

    private showTemplateExplorerSidebar(id: number, show: boolean) {
        const instance = this.getInstanceState(id);

        instance.showDirsTemplatesSidebar = show;
    }

    private workspaceSave(id: number) {
        this._state.actionLoading = true;
    }

    private workspaceSaveFinish(
        success: boolean,
        id: number,
        dirId,
        name: string,
        data: string,
        dateUpdated: string,
        favouritesOrigin,
        origin,
        state?
    ) {
        this._state.actionLoading = false;

        if (id == null) {
            return;
        }

        const instance = this.getInstanceState(id);

        if (data != null) {
            instance.data = deserializeWorkspace(data, this.glob);
            instance.originalData = data;
        }

        if (name != null && favouritesOrigin !== true) {
            instance.name = name;
        }

        if (success) {
            instance.edititngStarted = false;

            if (dateUpdated != null) {
                instance.dateUpdated = dateUpdated;
            }

            if (origin != null) {
                this.workspaceReset(origin);
            }
        }

        if (state != null) {
            this.replaceWorkspaceState(JSON.parse(this.serializeWorkspaceState(state)), id);
        }
    }

    private workspaceSetState(id: number, tab: number, namespace, state) {
        this.setWorkspaceState(id, tab, namespace, state);
    }

    private workspaceWidgetSetHidden(id: number, hidden: boolean, tab: number) {
        const instance = this.getInstanceState(id);

        if (instance.hiddenInTabs == null) {
            instance.hiddenInTabs = [];
        }

        if (hidden) {
            if (tab != null && instance.hiddenInTabs.indexOf(tab) < 0) {
                instance.hiddenInTabs.push(tab);
            }
        } else {
            if (tab == null) {
                instance.hiddenInTabs = [];
            } else {
                const index = instance.hiddenInTabs.indexOf(tab);

                if (index >= 0) {
                    instance.hiddenInTabs.splice(index, 1);
                }
            }
        }
    }

    private workspaceSetTheme(id, tab, value) {
        if (id == null) {
            return;
        }

        const instance = this._state.instances[id];

        if (instance == null) {
            return;
        }

        if (instance.data.theme == null) {
            return;
        }

        instance.data.theme = value;
        instance.data = _.clone(instance.data);
    }

    private workspaceReset(id: number) {
        if (id == null) {
            return;
        }

        const instance = this._state.instances[id];

        if (instance == null || instance.data == null || instance.originalData == null) {
            return;
        }

        instance.edititngStarted = false;
        instance.data = deserializeWorkspace(instance.originalData, this.glob);

        _.each(instance.data.widgets, (widget) => {
            this.actions.widgetSave(widget.id, widget, true);
        });

        this.actions.workspaceResetFinish(id);

        // Resetting of Workspace must reload it from server.
        this.actions.workspaceViewLoadContent(id, true);
    }

    private workspaceLayoutReset(id: number) {
        if (id == null || this._state.instances[id] == null) {
            return;
        }

        const instance = this.getInstanceState(id);
        const { data } = instance;

        if (data == null || data.layout == null) {
            return;
        }

        instance.edititngStarted = false;

        _.each(data.layout.columns.concat(data.layout.rows), (obj) => {
            delete obj.min;
            delete obj.size;

            obj.ratio = 1;
        });

        instance.data = { ...data };
    }

    private workspaceLayoutSet(id: number, layout: IWidgetLayout) {
        if (id == null || this._state.instances[id] == null) {
            return false;
        }

        const instance = this.getInstanceState(id);

        if (instance.data == null) {
            return false;
        }

        // See Issue 92673.
        if (!instance.showGrid && instance.displayMode === 'widgets') {
            instance.edititngStarted = true;
        }

        instance.data.layout = layout;
        instance.data = { ...instance.data };
        return true;
    }

    private remove(success, id: number) {
        if (success !== true || id == null) {
            return;
        }

        delete this._state.instances[id];
    }

    private themeUpdateFinish(success, id, name, data) {
        if (success !== true) {
            return false;
        }

        this._state.instances = _.mapObject(this._state.instances, (inst) => {
            inst = _.clone(inst);
            inst.data = _.clone(inst.data);
            inst.data = deserializeWorkspace(inst.data, this.glob);

            return inst;
        });
    }

    private widgetSetRole(tab: number, widget: number, role: string) {
        let tabObj = this._state.widgetRoles[tab];

        if (tabObj == null) {
            tabObj = this._state.widgetRoles[tab] = {};
        }

        tabObj[widget] = role;
    }

    private widgetUnsetRole(tab: number, widget: number) {
        let tabObj = this._state.widgetRoles[tab];

        if (tabObj == null) {
            return;
        }

        delete tabObj[widget];
    }

    public getWidgetRoles(tab: number) {
        return this._state.widgetRoles[tab] || {};
    }

    public getWidgetLayoutPos(wsid: number, widgetID: number): number[] {
        const instance = this._state.instances[wsid];

        if (instance == null || instance.data == null) {
            return;
        }

        const { index } = this.findWidget(instance.data.widgets, widgetID);

        return instance.data.layout.pos[index] || null;
    }

    private setWorkspacePresentationMode(
        workspaceID: number,
        tabID: number,
        displayMode: DisplayMode,
        showGrid: boolean
    ) {
        if (tabID == null) {
            return false;
        }

        const instance = this._state.instances[workspaceID];

        if (instance == null) {
            return false;
        }

        const tabs = this.glob.AppStore.getTabs();

        let currentTab: ITab;

        if (tabID >= 0 && tabID < tabs.length) {
            currentTab = tabs[tabID];
        } else {
            currentTab = _.find(tabs, (tabObj) => {
                return tabObj.originTab === tabID || tabObj.id === tabID;
            });
        }

        if (currentTab == null) {
            return false;
        }

        const editMode = displayMode === 'widgets';

        if (editMode) {
            if (workspaceID != null) {
                let numberOfOpenedWorkspaces = 0;

                _.each(tabs, (tab) => {
                    if (tab.workspaceID === workspaceID) {
                        numberOfOpenedWorkspaces++;
                    }
                });

                if (numberOfOpenedWorkspaces > 1) {
                    this.actions.showNotification_Warning(
                        'This Workspace is opened in several tabs. Close other tabs to start editing.'
                    );

                    return false;
                }
            }
        }

        currentTab.mode = displayMode;
        instance.displayMode = displayMode;
        instance.showGrid = showGrid;

        if (instance.edititngStarted) {
            if (serializeWorkspace(instance.data, true) === instance.originalData) {
                instance.edititngStarted = false;
            }
        } else {
            instance.edititngStarted = showGrid || displayMode === 'widgets';
        }

        if (!editMode && instance.showDirsTemplatesSidebar) {
            this.actions.showWorkspaceTemplateSidebar(workspaceID, false);
        }

        if (displayMode === 'main') {
            const originalData = JSON.parse(instance.originalData) as IWorkspaceData;

            let attributeFilterRemoved = -1;
            let periodFilterRemoved = false;
            let drillDownMemberRemoved = false;

            const scanForRemovedWidgets = (
                parentWidget: IWidget,
                widgets: IWidget[],
                attributeFilterRemoved: number,
                periodFilterRemoved: boolean,
                drillDownRemoved: boolean
            ): {
                attributeFilterRemoved: number;
                periodFilterRemoved: boolean;
                drillDownRemoved: boolean;
            } => {
                let newAttributeFilterRemoved = attributeFilterRemoved;
                let newPeriodFilterRemoved = periodFilterRemoved;
                let newDrillDownRemoved = drillDownRemoved;

                _.each(widgets, (widget) => {
                    const widgetType = widget.type;
                    // some 'smart' users like VR just change widget type
                    const exists = _.find(instance.data.widgets, (instanceWidget) => {
                        return widget.id === instanceWidget.id && widgetType === instanceWidget.type;
                    });

                    if (exists == null) {
                        switch (widgetType) {
                            case config.widgetTypes.drillDown:
                                newDrillDownRemoved = true;
                                break;
                            case config.widgetTypes.periodFilter:
                                newPeriodFilterRemoved = true;
                                break;
                            case config.widgetTypes.attributeFilter:
                                newAttributeFilterRemoved = widget.id;
                                break;
                            default:
                                if (parentWidget != null && parentWidget.type === config.widgetTypes.drillDown) {
                                    newDrillDownRemoved = true;
                                }

                                const childWidgets = this.getChildWidgets(widget, widgetType);

                                if (Array.isArray(childWidgets) && childWidgets.length > 0) {
                                    const out = scanForRemovedWidgets(
                                        widget,
                                        childWidgets,
                                        newAttributeFilterRemoved,
                                        newPeriodFilterRemoved,
                                        newDrillDownRemoved
                                    );

                                    newAttributeFilterRemoved = out.attributeFilterRemoved;
                                    newPeriodFilterRemoved = out.periodFilterRemoved;
                                    newDrillDownRemoved = out.drillDownRemoved;
                                }
                        }
                    } else {
                        const childWidgets = this.getChildWidgets(widget, widgetType);

                        if (Array.isArray(childWidgets) && childWidgets.length > 0) {
                            const out = scanForRemovedWidgets(
                                widget,
                                childWidgets,
                                newAttributeFilterRemoved,
                                newPeriodFilterRemoved,
                                newDrillDownRemoved
                            );

                            newAttributeFilterRemoved = out.attributeFilterRemoved;
                            newPeriodFilterRemoved = out.periodFilterRemoved;
                            newDrillDownRemoved = out.drillDownRemoved;
                        }
                    }
                });

                return {
                    attributeFilterRemoved: newAttributeFilterRemoved,
                    periodFilterRemoved: newPeriodFilterRemoved,
                    drillDownRemoved: newDrillDownRemoved
                };
            };

            const scanResult = scanForRemovedWidgets(
                null,
                originalData.widgets,
                attributeFilterRemoved,
                periodFilterRemoved,
                drillDownMemberRemoved
            );

            if (
                scanResult.attributeFilterRemoved !== -1 ||
                scanResult.drillDownRemoved ||
                scanResult.periodFilterRemoved
            ) {
                const globalState = GlobalState.getGlobalState(this.glob, tabID);

                if (globalState != null) {
                    if (scanResult.periodFilterRemoved) {
                        globalState.dropPeriodFilter();
                    }

                    if (scanResult.attributeFilterRemoved !== -1) {
                        const existingFilterCollection = globalState.getAttributeFilterCollection();

                        if (existingFilterCollection != null) {
                            deleteWigetAttributeFilters(existingFilterCollection, scanResult.attributeFilterRemoved);
                        }
                    }

                    if (scanResult.drillDownRemoved) {
                        const existingFilterCollection = globalState.getAttributeFilterCollection();

                        if (existingFilterCollection != null) {
                            deleteClickToFilters(existingFilterCollection);
                        }
                    }
                }

                this.glob.AppActions.resetFilters(workspaceID, tabID, 'business-intelligence');
            }
        }

        return true;
    }

    private getChildWidgets(widget: IWidget, widgetType: string) {
        if (widgetType === config.widgetTypes.drillDown) {
            return (widget.values[widgetType] as IDrillDownWidgetParameters).drillDown.widgets;
        }

        return widget.values[widgetType].widgets;
    }

    protected eventsHandler(payload) {
        if (!super.eventsHandler(payload)) {
            return false;
        }

        const action = payload.action;
        const _case = checkAction;

        do {
            if (_case<I.WORKSPACE_VIEW_SHOW>(action, Constants.WORKSPACE_VIEW_SHOW)) {
                this.workspaceShow(action.id, action.stateId, action.distractFree, action.activeWidgets);
                this.emitChangeWithoutSaving();
                break;
            }

            if (_case<I.WORKSPACE_VIEW_HIDE>(action, Constants.WORKSPACE_VIEW_HIDE)) {
                //this.workspaceHide(a.id);
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_WIDGET_SET_HIDDEN>(action, Constants.WORKSPACE_WIDGET_SET_HIDDEN)) {
                this.workspaceWidgetSetHidden(action.id, action.hidden, action.tab);
                break;
            }

            if (_case<I.WORKSPACE_VIEW_CLOSE>(action, Constants.WORKSPACE_VIEW_CLOSE)) {
                //this.workspaceViewClose(a.id, a.tabIndex);
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_CLEAR_CACHE>(action, Constants.WORKSPACE_CLEAR_CACHE)) {
                this.workspaceClearCache(action.id);
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_SHOW_SIDEBAR>(action, Constants.WORKSPACE_SHOW_SIDEBAR)) {
                if (this.workspaceShowSidebar()) {
                    this.emitChangeWithoutSaving();
                }
                break;
            }

            if (_case<I.WORKSPACE_HIDE_SIDEBAR>(action, Constants.WORKSPACE_HIDE_SIDEBAR)) {
                if (this.workspaceHideSidebar()) {
                    this.emitChangeWithoutSaving();
                }
                break;
            }

            if (_case<I.WORKSPACE_VIEW_CONTENT_LOAD>(action, Constants.WORKSPACE_VIEW_CONTENT_LOAD)) {
                this.workspaceLoadContent(action.id, action.silent, action.stateId, action.distractFree);
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_VIEW_CONTENT_LOAD_FINISH>(action, Constants.WORKSPACE_VIEW_CONTENT_LOAD_FINISH)) {
                this.workspaceLoadContentFinish(action.id, action.success);
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_TEMPLATES_EXPLORER_SHOW>(action, Constants.WORKSPACE_TEMPLATES_EXPLORER_SHOW)) {
                this.templatesExplorerShow();
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_TEMPLATES_EXPLORER_HIDE>(action, Constants.WORKSPACE_TEMPLATES_EXPLORER_HIDE)) {
                this.templatesExplorerHide();
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_NOTIFY_FOREIGN_UPDATE>(action, Constants.WORKSPACE_NOTIFY_FOREIGN_UPDATE)) {
                this.workspaceForeignUpdate(action.id, action.dateUpdated, action.updatedBy);
                this.emitChange();
                break;
            }

            if (_case<I.SHOW_WORKSPACE_TEMPLATE_SIDEBAR>(action, Constants.SHOW_WORKSPACE_TEMPLATE_SIDEBAR)) {
                this.showTemplateExplorerSidebar(action.workspace, action.show);
                this.emitChange();
                break;
            }

            if (_case<I.WIDGET_SAVE>(action, Constants.WIDGET_SAVE)) {
                this.widgetSave(action.id, action.data, action.ignoreWorkspace, action.local, action.workspaceID);
                this.emitChange();
                break;
            }

            if (_case<I.WIDGET_CREATE>(action, Constants.WIDGET_CREATE)) {
                this.emitChange(
                    this.widgetCreate(
                        action.wsId,
                        action.parentWidgetId,
                        action.cid,
                        action.data,
                        action.wsName,
                        action.isVirtual
                    )
                );
                break;
            }

            if (_case<I.WIDGET_REMOVE>(action, Constants.WIDGET_REMOVE)) {
                this.widgetRemove(action.id);
                this.emitChange();
                break;
            }

            if (_case<I.WIDGET_DETACH>(action, Constants.WIDGET_DETACH)) {
                this.widgetDetach(action.id);
                this.emitChange();
                break;
            }

            if (_case<I.WIDGET_ATTACH>(action, Constants.WIDGET_ATTACH)) {
                this.emitChange(
                    this.widgetAttach(
                        action.wsId,
                        action.parentWidgetId,
                        action.id,
                        action.x,
                        action.y,
                        action.remainSize,
                        action.fresh
                    )
                );
                break;
            }

            if (_case<I.WIDGET_CREATE_LINK>(action, Constants.WIDGET_CREATE_LINK)) {
                this.widgetCreateLink(
                    action.workspace,
                    action.widget,
                    action.name,
                    action.state,
                    action.widgetData,
                    action.options
                );
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_CREATE_LINK>(action, Constants.WORKSPACE_CREATE_LINK)) {
                this.workspaceCreateLink(action.workspace, action.tab, action.name, action.params, action.options);
            }

            if (_case<I.WIDGET_SET_LAYOUT>(action, Constants.WIDGET_SET_LAYOUT)) {
                this.widgetSetLayout(action.workspace, action.widget, action.layout);
                this.emitChange();
                break;
            }

            if (_case<I.WIDGET_ADD_FIELD>(action, Constants.WIDGET_ADD_FIELD)) {
                this.widgetAddField(action.workspace, action.widget, action.x, action.y, action.field);
                this.emitChange();
                break;
            }

            if (_case<I.WIDGET_REMOVE_FIELD>(action, Constants.WIDGET_REMOVE_FIELD)) {
                this.widgetRemoveField(action.workspace, action.widget, action.positionIndex, action.shift);
                this.emitChange();
                break;
            }

            if (_case<I.WIDGET_MULTIPLE_SET_ACTIVE>(action, Constants.WIDGET_MULTIPLE_SET_ACTIVE)) {
                if (this.widgetMultipleSetActive(action.workspace, action.parentWidgetID, action.activeWidgetID)) {
                    this.emitChange();
                }
                break;
            }

            if (_case<I.WIDGET_DRILLDOWN_SET_STATE>(action, Constants.WIDGET_DRILLDOWN_SET_STATE)) {
                this.widgetDrillDownSetState(action.workspace, action.drillDownWidget, action.targetWidget);
            }

            if (_case<I.WORKSPACE_SAVE>(action, Constants.WORKSPACE_SAVE)) {
                this.workspaceSave(action.id);
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_SAVE_FINISH>(action, Constants.WORKSPACE_SAVE_FINISH)) {
                this.workspaceSaveFinish(
                    action.success,
                    action.id,
                    action.dirId,
                    action.name,
                    action.data,
                    action.dateUpdated,
                    action.favouritesOrigin,
                    action.origin,
                    action.state
                );
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_SET_STATE>(action, Constants.WORKSPACE_SET_STATE)) {
                this.emitChange(this.workspaceSetState(action.id, action.tab, action.namespace, action.state));
                break;
            }

            if (_case<I.WORKSPACE_SET_THEME>(action, Constants.WORKSPACE_SET_THEME)) {
                this.workspaceSetTheme(action.id, action.tab, action.value);
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_RESET>(action, Constants.WORKSPACE_RESET)) {
                this.workspaceReset(action.id);
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_LAYOUT_RESET>(action, Constants.WORKSPACE_LAYOUT_RESET)) {
                this.workspaceLayoutReset(action.id);
                this.emitChange();
                break;
            }

            if (_case<I.WORKSPACE_LAYOUT_SET>(action, Constants.WORKSPACE_LAYOUT_SET)) {
                if (this.workspaceLayoutSet(action.id, action.layout)) {
                    this.emitChange();
                }
                break;
            }

            if (_case<I.WORKSPACE_DELETE_FINISH>(action, Constants.WORKSPACE_DELETE_FINISH)) {
                this.remove(action.success, action.id);
                this.emitChange();
                break;
            }

            if (_case<I.THEME_UPDATE_FINISH>(action, Constants.THEME_UPDATE_FINISH)) {
                this.emitChange(this.themeUpdateFinish(action.success, action.id, action.name, action.data));
                break;
            }

            if (_case<I.WIDGET_SET_ROLE>(action, Constants.WIDGET_SET_ROLE)) {
                this.widgetSetRole(action.tab, action.widget, action.role);
                break;
            }

            if (_case<I.WIDGET_UNSET_ROLE>(action, Constants.WIDGET_UNSET_ROLE)) {
                this.widgetUnsetRole(action.tab, action.widget);
                break;
            }

            if (_case<I.WORKSPACE_SAVE_STATE>(action, Constants.WORKSPACE_SAVE_STATE)) {
                this.saveState();
                break;
            }

            if (_case<IW.SET_WORKSPACE_PRESENTATION_MODE>(action, Constants.SET_WORKSPACE_PRESENTATION_MODE)) {
                if (
                    this.setWorkspacePresentationMode(
                        action.workspaceID,
                        action.tab,
                        action.displayMode,
                        action.showGrid
                    )
                ) {
                    this.emitChange();
                }
                break;
            }
        } while (false);

        return true;
    }

    constructor(glob: IGlob, dispatcher: Dispatcher, actions: AppActions) {
        super(glob, dispatcher, actions, WorkspaceStore._name);

        this._state = _.extend(WorkspaceStore.getInitialState(), this._state);
    }

    public static get(glob: IGlob, dispatcher: Dispatcher, actions: AppActions) {
        return new WorkspaceStore(glob, dispatcher, actions);
    }
}
